import React from 'react';
import classes from './SkeletonLoader.module.css'

const SkeletonLoader = () => {
    return (
        <div className={classes.loaderBox}>
        <div className={classes.sk_loader}>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
        </div>
        <div className={classes.sk_loader}>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
        </div>
        <div className={classes.sk_loader}>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
        </div>
        <div className={classes.sk_loader}>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
        </div>
        <div className={classes.sk_loader}>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
        </div>
        <div className={classes.sk_loader}>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
            <span className={classes.skeleton_box}></span>
        </div>
        </div>
    );
};

export default SkeletonLoader;